__turbopack_context__.v({
  "button": "pEsOUa_button",
  "container": "pEsOUa_container",
  "divider": "pEsOUa_divider",
  "hasSubmenu": "pEsOUa_hasSubmenu",
  "item": "pEsOUa_item",
  "submenu": "pEsOUa_submenu",
  "themeSwitcher": "pEsOUa_themeSwitcher",
  "variant--patreon": "pEsOUa_variant--patreon",
});
